import { useCallback, useState } from 'react';
import { useStyles } from './card-produto-subitem-styles';
import SemImagem from 'assets/img/sem-imagem.jpg';
import { toDecimalString } from 'utils/to-decimal';
import { AddESub } from './components/add-e-sub/button-add-e-sub';
import { isEmpty } from 'lodash';
import { EnumTpCalculoModificador, EnumTpProduto, MovSimplesProdutoModel } from 'api/cardapio/models/produto/mov-simples-produto-model';
import { MovSimplesModificadoresProdutoModel } from 'api/cardapio/models/produto/mov-simples-modificadores-produto-model';
import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { DefaultCard } from 'components/default-card';

type CardSubitemProps = {
  produto: MovSimplesProdutoModel;
  handleClickAddOrSub: (
    tpProduto: EnumTpProduto,
    valorProdutoPai: number,
    produto: MovSimplesProdutoModel,
    qtd: number,
    modificador?: MovSimplesModificadoresProdutoModel,
    prodGradeId?: string,
    fator?: 'add' | 'sub'
  ) => Promise<void>;
  verificar?: boolean;
  showValue?: boolean;
  edit?: boolean;
  qtdPai: number;
  qtdModificador?: number;
  valorProdutoPai: number;
  tpProdutoPai: EnumTpProduto;
  modificador?: MovSimplesModificadoresProdutoModel | null;
};

export const CardSubitem = ({
  produto,
  handleClickAddOrSub,
  verificar,
  showValue,
  edit,
  qtdPai,
  qtdModificador,
  valorProdutoPai = 0,
  tpProdutoPai,
  modificador
}: CardSubitemProps) => {
  // STATES E REFS
  const [qtd, setQtd] = useState<number>(produto.qCom);

  // AUX
  const classes = useStyles();

  const img = useCallback(
    (imagemUrl?: string) => {
      try {
        if (imagemUrl && imagemUrl?.length > 0) {
          return (
            <img
              src={imagemUrl}
              className={classes.cardImg}
              alt={produto.xProd}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = SemImagem;
              }}
            />
          );
        }

        return (
          <img
            src={SemImagem}
            className={classes.cardImg}
            alt={produto.xProd}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = SemImagem;
            }}
          />
        );
      } catch (err) {
        return (
          <img
            src={SemImagem}
            className={classes.cardImg}
            alt={produto.xProd}
          />
        );
      }
    },
    [classes.cardImg, produto.xProd]
  );

  if (edit && verificar && produto.qCom < 0) {
    return null;
  }

  const retornaSubTotalDeCadaProduto = (tipoDeCalculo: number, modificador?: MovSimplesModificadoresProdutoModel | null, semQtdPadrao?: boolean) => {
    const multiplicadorPadrao = produto.qComModificador > 0
      ? produto.qComModificador
      : semQtdPadrao ? qtd : qtd - produto.infoSubItem!.qPadrao;
    if (modificador) {
      switch (tipoDeCalculo) {
        case EnumTpCalculoModificador.Maior:
          return produto.vFinal
        case EnumTpCalculoModificador.Rateia:
          return produto.vFinal
        default: return multiplicadorPadrao * produto.vUnCom
      }
    }
    return multiplicadorPadrao * produto.vUnCom
  }

  const subTotalProduto = (semQtdPadrao: boolean) => {
    return `+ R$ ${toDecimalString(
      retornaSubTotalDeCadaProduto(modificador?.tpCalculo ?? 0, modificador, semQtdPadrao)
      , 2
    )}`
  }

  return (
    <DefaultCard hasTagStatus={false} onClick={async (event) => {
      event.stopPropagation()
      // if (
      //   qtd >= (produto.infoSubItem?.qMax ?? 100) ||
      //   !produto.ativo ||
      //   verificar ||
      //   (modificador && modificador.qAtual >= modificador.qMax)
      // )
      //   return

      // setQtd((prev) => {
      //   handleClickAddOrSub(produto.tpProduto, valorProdutoPai, produto, qtd + 1, undefined, '', 'add')
      //   return prev + 1;
      // });
    }}>
      {/* {produto.subItens && produto.subItens.length > 0 && (
        <Typography
          variant="caption"
          className={classes.textInfoPersonalizavel}
        >
          Personalizável
        </Typography>
      )} */}

      <Grid className={classes.cardContainer}>
        <Grid style={{ display: 'flex', flex: 1, alignItems: 'center' }}>
          {img(produto.imgUrl)}

          <Grid
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginLeft: 4,
              justifyContent: 'center'
            }}
          >
            <Typography
              variant="body1"
              style={{ fontWeight: 600, fontSize: '14px' }}
            >
              {produto.xProd}
            </Typography>
            {!isEmpty(produto.infAdic) && <Typography
              variant="body1"
              style={{ fontSize: '12px' }}
            >
              {produto.infAdic}
            </Typography>}
            <Typography
              variant="body1"
              style={{ fontWeight: 400, fontSize: '12px', height: '14.4px' }}
            >
              <span className={verificar && showValue ? '' : classes.invisible}>
                {subTotalProduto(true)}
              </span>
              <span className={produto.infoSubItem!.qPadrao >= qtd || verificar ? classes.invisible : ''}>
                {subTotalProduto(false)}
              </span>
            </Typography>
          </Grid>
        </Grid>
        <Grid style={{ display: 'flex', justifyContent: 'center' }}>
          <AddESub
            qtd={qtd}
            setQtd={setQtd}
            model={produto}
            alterarQtdeProduto={handleClickAddOrSub}
            verificar={verificar}
            qtdModificador={qtdModificador}
            valorProdutoPai={valorProdutoPai}
            tpProdutoPai={tpProdutoPai}
          />
        </Grid>
      </Grid>
    </DefaultCard>
  );
};
